import React from 'react'
import {createContext, useState} from "react"
import axios from "axios"
import { config } from "../config";

const AuthContext = createContext()
export default AuthContext;

export const AuthProvider = ((props) => {
   
    const[currentUser, setCurrentUser] = useState(
        localStorage.getItem("user") || null
    )

    const checkServerCode = (code) => {
        /*
        console.log("Server code:", code)
        if (code === "ERR-NETWORK")
            return 409
        else
            return 400
        */

        return code

    }

    const getSecurityQuestions = async (inputs) => {
       
        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/getsecuritydata", inputs,{
                withCredentials:true
            })
            //console.log("GetSecurityQuestions response: ", res)
          
            return res;
        }
        catch (err){
            console.log("GetSecurityQuestions err:", err)
            return err
        }
    }

    const login = async (inputs) => {
       
        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/auth/login", inputs,{
                withCredentials:true
            })
           console.log("Logon response: ", res)
            localStorage.setItem("user", res.data.username)
            setCurrentUser(res.data.username)
            return 200;
        }
        catch (err){
            console.log("Login err:", err)
            localStorage.setItem("user", "")
            
            return checkServerCode(err.code)
        }
    }

    const logout = () => {
       
        console.log("Logout")
        localStorage.setItem("user", "")
        setCurrentUser("")
    }

    const checkCurrentUser = () => {
        if (currentUser !== null && currentUser.length > 0)
            return true;
        else return false;
    }

    const saveCurrentUser = (user) => {
        localStorage.setItem("user", user)
        setCurrentUser(user)
    }

   
    return <AuthContext.Provider value={{
        currentUser,
        setCurrentUser,
        login,
        logout,
        checkCurrentUser,
        getSecurityQuestions,
        saveCurrentUser,
        checkServerCode
        }}>
            {props.children}
        </AuthContext.Provider>
})
